var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav-component',{attrs:{"routes":_vm.routes},scopedSlots:_vm._u([{key:"right_dropdown",fn:function(){return [_c('search-btn'),_c('social-links')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }